module.exports = __webpack_public_path__ + "img/offensive_kodo_farm_small.1a61d29b.png";